import React, { useEffect, useContext } from 'react'
// Components
import UIFilters from './Filters'
import Table from './Table/TableWithAdd'
// Additional
import { Tab } from 'static/tabs'
import { AppContext } from 'App'

const Select: React.FC = () => {
  const { location: a_location } = useContext(AppContext)

  useEffect(() => {
    a_location?.set(Tab.Rounds)
  }, [])

  return (
    <>
      <UIFilters />
      <Table />
    </>
  )
}

export default Select
